export default __webpack_public_path__ + "static/media/noSound.510371e6.mp3";